module.exports = "//cdn.mxpnl.com/static/asset-cache/c10ec451f19ff6dc53c5b825e79b4087/iron/common/assets/images/charts/sankey.svg";